import { z } from "zod";
import { gql } from "graphql-request";
import { NewsEntry } from "./newsEntry";

import { NewsEntryArticleFragment, NewsEntryArticle } from "./newsEntryArticle";
import { NewsEntryVideoFragment, NewsEntryVideo } from "./newsEntryVideo";
import {
  NewsEntryExternalLinkFragment,
  NewsEntryExternalLink,
} from "./newsEntryExternalLink";
import { SysFragment } from "../sys";
import {
  SmallNewsEntryExternalLinkFragment,
  SmallNewsEntryExternalLink,
} from "./smallNewsEntryExternalLink";
import {
  SmallNewsEntryArticleFragment,
  SmallNewsEntryArticle,
} from "./smallNewsEntryArticle";

import {
  EsportRewatchMatchEntry,
  EsportRewatchMatchEntryFragment,
} from "./esportRewatchMatchEntry";
import { TargetingFragment } from "../targeting";
import { RelatedMediaFragment } from "../relatedMedia";

export const EsportNewsEntry = NewsEntry.extend({
  localized: z
    .discriminatedUnion("__typename", [
      NewsEntryArticle,
      NewsEntryVideo,
      NewsEntryExternalLink,
      SmallNewsEntryArticle,
      SmallNewsEntryExternalLink,
      EsportRewatchMatchEntry,
    ])
    .nullish(),
});

export type EsportNewsEntry = z.infer<typeof EsportNewsEntry>;

export const EsportNewsEntryFragment = gql`
  fragment EsportNewsEntryFragment on EsportNewsEntry {
    sys {
      ...SysFragment
    }
    category {
      name
      color
      secondaryColor
    }
    newUntil
    sortDate

    targeting {
      ...TargetingFragment
    }

    relatedMedia {
      ...RelatedMediaFragment
    }

    localized {
      __typename

      ... on NewsEntryVideo {
        ...NewsEntryVideoFragment
      }

      ... on NewsEntryExternalLink {
        ...NewsEntryExternalLinkFragment
      }

      ... on NewsEntryArticle {
        ...NewsEntryArticleFragment
      }

      ... on SmallNewsEntryArticle {
        ...SmallNewsEntryArticleFragment
      }

      ... on SmallNewsEntryExternalLink {
        ...SmallNewsEntryExternalLinkFragment
      }

      ... on EsportRewatchMatchEntry {
        ...EsportRewatchMatchEntryFragment
      }
    }
  }

  ${NewsEntryArticleFragment}
  ${NewsEntryVideoFragment}
  ${NewsEntryExternalLinkFragment}
  ${SmallNewsEntryExternalLinkFragment}
  ${SmallNewsEntryArticleFragment}
  ${EsportRewatchMatchEntryFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
  ${SysFragment}
`;
